// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"LicenseAgreement__checkboxContainer--1BN4-","la":"LicenseAgreement__la--3NkTO","text":"LicenseAgreement__text--yYtGY"};